var Vendd = (function (Vendd) {
    'use strict';


    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.GetModel, Vendd.StockTrackerSystem, function (envelope) {
        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.GetModelSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.GetModelFailed(response));
            }
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.GetModelFailed(response));
        }
        var options = {
            method: 'POST',
            url: 'api/StockTrackerSystem/GetModel',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.Remove, Vendd.StockTrackerSystem, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.RemoveSuccess());
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.RemoveFailed(response));
        }
        
        var options = {
            url: 'api/StockTrackerSystem/Remove',
            data: {
                VinNumber: envelope.message.data.VinNumber
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.ConfirmInventory, Vendd.StockTrackerSystem, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.ConfirmInventorySuccess());
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.ConfirmInventoryFailed(response));
        }

        var options = {
            url: 'api/StockTrackerSystem/ConfirmInventory',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.UndoConfirmInventory, Vendd.StockTrackerSystem, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.UndoConfirmInventorySuccess());
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.UndoConfirmInventoryFailed(response));
        }

        var options = {
            url: 'api/StockTrackerSystem/UndoConfirmInventory',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.GetSubPartners, Vendd.StockTrackerSystem, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.GetSubPartnersSuccess(response));
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.GetSubPartnersFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/StockTrackerSystem/GetSubPartners',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.StockTrackerSystem.Messages.ChangePartner, Vendd.StockTrackerSystem, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.ChangePartnerSuccess(response));
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.StockTrackerSystem, new Vendd.StockTrackerSystem.Messages.ChangePartnerFailed(response));
        }

        var options = {
            method: 'POST',
            url: 'api/StockTrackerSystem/ChangePartner',
            data: {
                ProductIdentifier: envelope.message.data.ProductIdentifier,
                PartnerItemId: envelope.message.data.PartnerItemId
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });
    
	return Vendd;

})(Vendd || {});